// Copyright (c) 2026 Aravind Adari. All rights reserved.

interface Props {
  size?: number;
}

export default function StarOneLogo({ size = 32 }: Props) {
  return (
    <img
      src="/logo.png"
      alt="StarOne Logo"
      width={size}
      height={size}
      style={{ borderRadius: size * 0.15, objectFit: "contain", display: "block", flexShrink: 0 }}
    />
  );
}
